import * as types from './types';

const INITIAL_STATE = {
  reimbursementRates: [],
  report: null,
  fetching: false,
  fetchError: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.REVENUE_SUMMARY_REPORT_GET_REIMBURSEMENT_RATES:
      const { data } = payload;
      const newValues = data.map((value, index) => {
        return {
          value: value.Id,
          text: value.Description,
          key: index,
        };
      });
      return {
        ...state,
        reimbursementRates: newValues,
      };

    case types.REVENUE_SUMMARY_REPORT_FETCHING:
      return { ...state, fetching: payload };

    case types.REVENUE_SUMMARY_REPORT_FETCH_ERROR:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };

    case types.REVENUE_SUMMARY_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/state/report/reducer.js